export const levelColors = {
  fatal: 'danger',
  error: 'danger',
  warning: 'warning',
  info: 'info',
  debug: 'default',
}

export const projectColors = {
  API: 'bg-blue-100 text-blue-700',
  Mobile: 'bg-purple-100 text-purple-700',
  Portal: 'bg-green-100 text-green-700',
}

export const statusColors = {
  unresolved: 'danger',
  resolved: 'success',
  ignored: 'default',
}
